import React from "react";
import { Alert, Button, Form } from "react-bootstrap";
import {
  FormikProps,
  FormikErrors,
  FormikTouched,
  FormikHandlers,
} from "formik";
import { capWord } from "../utils/types";

interface FormValues {
  camera: string;
  date: string;
  insight: string;
  keywords: string;
  suburb: string;
  name: string;
  orientation: string;
  postcode: string;
  provider: string;
  // sensitivity: string;
  street: string;
  // thumbnail: any[];
  submit: boolean;
  videoURL: string;
}
interface inputPropsType {
  each: string;
  touched: FormikTouched<FormValues>;
  errors: FormikErrors<FormValues>;
  values: FormValues;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChange2: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleBlur2: (e: React.FocusEvent<HTMLSelectElement>) => void;
}

function VideoInfoInput(props: inputPropsType) {
  const {
    each,
    touched,
    errors,
    values,
    handleChange,
    handleBlur,
    handleBlur2,
    handleChange2,
  } = props;
  if (each === "date") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Date & Time :</Form.Label>
          <Form.Control
            required
            size="sm"
            type="datetime-local"
            name="date"
            placeholder="DD/mm/yyyy, hh:mm am/pm"
            value={values.date}
            isInvalid={Boolean(touched.date && errors.date)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          {!!(touched as any)[each] && (
            <Form.Control.Feedback type="invalid">
              {(errors as any)[each]}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </>
    );
  }
  if (each === "provider") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Provider :</Form.Label>
          <Form.Select
            required
            name={each}
            value={(values as any)[each]!}
            isInvalid={Boolean((touched as any)[each] && (errors as any)[each])}
            onBlur={handleBlur2}
            onChange={handleChange2}
          >
            <option value=""> Please pick a provider </option>
            <option value="sls"> SLS </option>
          </Form.Select>
        </Form.Group>
      </>
    );
  }
  if (each === "orientation") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Orientation :</Form.Label>
          <Form.Select
            required
            name="orientation"
            onBlur={handleBlur2}
            onChange={handleChange2}
            value={(values as any)[each]!}
          >
            <option value=""> Please pick a camera direction </option>
            <option value="n"> North </option>
            <option value="ne"> Northeast </option>
            <option value="e"> East </option>
            <option value="se"> Southeast </option>
            <option value="s"> South </option>
            <option value="sw"> Southwest </option>
            <option value="w"> West </option>
          </Form.Select>
        </Form.Group>
      </>
    );
  }
  if (each === "sensitivity") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Sensitivity :</Form.Label>
          <Form.Select
            required
            name={each}
            value={(values as any)[each]!}
            isInvalid={Boolean((touched as any)[each] && (errors as any)[each])}
            onBlur={handleBlur2}
            onChange={handleChange2}
          >
            <option value=""> Please pick the sensitivity level </option>
            <option value="public"> Public </option>
            <option value="sharing"> Sharing </option>
            <option value="internal"> Internal </option>
          </Form.Select>
        </Form.Group>
      </>
    );
  }
  if (each === "keywords") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>
            Keywords : (seperate each keyword with , comma )
          </Form.Label>
          <Form.Control
            required
            size="sm"
            type="text"
            name={each}
            placeholder=""
            value={(values as any)[each]!}
            isInvalid={Boolean((touched as any)[each] && (errors as any)[each])}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          {!!(touched as any)[each] && (
            <Form.Control.Feedback type="invalid">
              {(errors as any)[each]}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </>
    );
  }
  if (each === "location") {
    return (
      <>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Location : camera coordinates</Form.Label>
          <Form.Control
            required
            size="sm"
            type="text"
            name={each}
            placeholder="lat , long"
            value={(values as any)[each]!}
            isInvalid={Boolean((touched as any)[each] && (errors as any)[each])}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          {!!(touched as any)[each] && (
            <Form.Control.Feedback type="invalid">
              {(errors as any)[each]}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </>
    );
  }
  if (each === "thumbnail") {
    return <></>;
  }
  return (
    <>
      <Form.Group className="mb-3 text-start">
        <Form.Label>
          {each === "camera" ? "Camera no." : capWord(each)}
        </Form.Label>
        <Form.Control
          required
          size="sm"
          type="text"
          name={each}
          placeholder=""
          value={(values as any)[each]!}
          isInvalid={Boolean((touched as any)[each] && (errors as any)[each])}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {!!(touched as any)[each] && (
          <Form.Control.Feedback type="invalid">
            {(errors as any)[each]}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </>
  );
}

export default VideoInfoInput;
